import { useMutation } from 'glimmer-apollo'
import { parse, print } from 'graphql'
import { QUOTE_FRAGMENT } from 'customer-flows/gql/fragments/quote'

export function updateQuote(
  context: Object,
  variables: QuoteSparseInput,
  quoteId: string
): Promise<UpdateQuoteResponse | undefined | null> {
  return new Promise((resolve, reject) => {
    const updateQuoteMutation = useMutation<UpdateQuoteResponse, UpdateQuoteInput>(context, () => [
      mutation,
      {
        onError: (error) => {
          reject(error)
        },
        onComplete: (data: UpdateQuoteResponse | undefined | null) => {
          resolve(data)
        }
      }
    ])

    updateQuoteMutation.mutate({
      input: {
        quoteInput: variables,
        quoteId
      }
    })
  })
}

const mutation = parse(`
  mutation UpdateQuote($input: UpdateQuoteV2Input!) {
    updateQuoteV2(input: $input) {
      quote {
        ...QuoteFragment
      }
      errors {
        code
        detail
        value
      }
      warnings {
        message
      }
    }
  }
  ${print(QUOTE_FRAGMENT)}
`)
